import React from "react";
import Navbar from "./Navbar";
import BarresearchP from "../../COMPONENTS/BarreSearchP/BarreSearchP";
import accueil from "../../../ASSETS/tourisme/Image/accueilVehicule.png";
import { useTranslation } from "react-i18next";

function BackImage() {
  const { t } = useTranslation() as { t: (key: string) => string };
  let code = localStorage.getItem("code");
  let iso_code = localStorage.getItem("is_code");
  return (
    <div>
      {/* navbar */}
      <Navbar />
      {/* back image */}
      <div className='bg-cover z-0 flex-col bg-center bg-no-repeat h-96 w-screen relative flex justify-center items-center' style={{ backgroundImage: `url(${accueil})` }}>
              <div className='flex flex-col items-center justify-center space-y-5 sm:pt-40 md:pt-0'>
                  <div className='navbar_animation text-white md:text-7xl xs:text-5xl s:text-2xl font-semibold uppercase '>
                      {t("Location de véhicule")}
                  </div>
              </div>
          </div>
     

      {/* barre de recherche principale */}
      {/* <div className=' absolute inset-x-0 md:-bottom-20 xs:-bottom-40 s:-bottom-64 flex justify-center  '>
              <BarresearchP cde={code ? code : iso_code} />
          </div> */}

      {/* title */}
      <div className="relative md:mt-10 s:mt-2 flex flex-col justify-center items-center space-y-5  pb-10" id="voir-plus">
        <p className="text-center font-semibold xs:text-2xl s:text-xl">
          <span className="text-yellow-400">
            {t("PLUS DE 100 VÉHICULES DISPONIBLES")}
          </span>{" "}
          {t("POUR VOS LOCATIONS")}
        </p>
        <p className="text-center s:w-[260px] sm:w-[340px] md:w-[850px] xs:w-[600px] text-lg">
          {t(
            "Explorez la liberté de voyager à votre rythme avec notre service de location de véhicules. Des options variées, des tarifs compétitifs et un service client dévoué font de chaque trajet une aventure sans souci"
          )}
          .
        </p>
      </div>
    </div>
  );
}

export default BackImage;
